export default "__VITE_ASSET__i1BxvL7J__"